import {
    FETCH_TIPOS_INGRESO_SUCCESS,
    FETCH_TIPOS_INGRESO_FAILURE,
    FETCH_TIPO_INGRESO_SUCCESS,
    FETCH_TIPO_INGRESO_FAILURE,
    CREATE_TIPO_INGRESO_SUCCESS,
    CREATE_TIPO_INGRESO_FAILURE,
    UPDATE_TIPO_INGRESO_SUCCESS,
    UPDATE_TIPO_INGRESO_FAILURE,
    DELETE_TIPO_INGRESO_SUCCESS,
    DELETE_TIPO_INGRESO_FAILURE,
  } from '../actions/tipoIngresoActions';
  
  const initialState = {
    tiposIngreso: [],
    currentTipoIngreso: null,
    error: null,
  };
  
  const tipoIngresoReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TIPOS_INGRESO_SUCCESS:
        return {
          ...state,
          tiposIngreso: action.payload,
          error: null,
        };
      case FETCH_TIPOS_INGRESO_FAILURE:
      case FETCH_TIPO_INGRESO_FAILURE:
      case CREATE_TIPO_INGRESO_FAILURE:
      case UPDATE_TIPO_INGRESO_FAILURE:
      case DELETE_TIPO_INGRESO_FAILURE:
        return {
          ...state,
          error: action.payload,
        };
      case FETCH_TIPO_INGRESO_SUCCESS:
        return {
          ...state,
          currentTipoIngreso: action.payload,
          error: null,
        };
      case CREATE_TIPO_INGRESO_SUCCESS:
        return {
          ...state,
          tiposIngreso: [...state.tiposIngreso, action.payload],
          error: null,
        };
      case UPDATE_TIPO_INGRESO_SUCCESS:
        return {
          ...state,
          tiposIngreso: state.tiposIngreso.map((tipo) =>
            tipo.id === action.payload.id ? action.payload : tipo
          ),
          currentTipoIngreso: action.payload,
          error: null,
        };
      case DELETE_TIPO_INGRESO_SUCCESS:
        return {
          ...state,
          tiposIngreso: state.tiposIngreso.filter((tipo) => tipo.id !== action.payload),
          error: null,
        };
      default:
        return state;
    }
  };
  
  export default tipoIngresoReducer;